import { ListingStatus, OfferListingStatus, PaymentTerms, PricingUnit, Product, RFQStatus } from '@steelbuy/ts-shared';
import { AddressIdentifier } from '@steelbuy/ui-primitive';
import { Steps } from '../app/components/create-listing/CreateListingContext.enums';
import { RFQStep } from '../app/components/create-rfq/CreateRFQ.enums';

export default {
    constants: {
        primaryAddress: {
            line1: 'Regus',
            line2: 'Central Boulevard',
            line3: 'Blythe Valley Business Park',
            line4: 'Solihull',
            line5: 'West Midlands',
            country: 'England',
            postcode: 'B90 8AG',
        },
        customerServicePhone: '',
        companyRegistrationNumber: '',
        taxNumber: '',
        copyright: 'Copyright SteelBuy Ltd. 2022',
        companyName: 'SteelBuy Limited',
        companyNumber: '01914559',
        customerServiceTel: '+44 (0) 121 713 7280',
        emailSupport: 'support@steel-buy.com',
        registerLink: 'https://steel-buy.com/account-registration/',
        emailInfo: 'info@steel-buy.com',
        tkCompanyName: 'thyssenkrupp Materials (UK) Ltd',
        trademarkNumber: 'UK00004153752',
        registrationNumber: 'UK00004156426',
        logoRegistrationNumber: 'UK00004153738',
        vatNumber: 'GB 695 9678 44',
        website: 'steel-buy.com',
        marketplace: 'steelbuy.app',
    },
    application: {
        acceptabelUsePolicy: {
            headerTitle: 'Richtlinien zur akzeptablen Nutzung',
        },
        account: {
            headerTitle: 'Konto',
            headerButtonAddNewUser: 'Neuen Benutzer hinzufügen',
            tabMyAccount: 'Mein Konto',
            tabOrganisation: 'Unternehmen',
            tabUserManagement: 'Benutzerverwaltung',
        },
        accountAddAddress: {
            errorMessage: 'Adresse konnte nicht hinzugefügt werden. ',
            pageTitle: 'Lageradresse hinzufügen',
            previousPageTitle: 'Organisationskonto',
        },
        accountEditAddress: {
            errorMessage: 'Adresse konnte nicht bearbeitet werden. ',
            pageTitleInvoiceAddress: 'Rechnungsadresse bearbeiten',
            pageTitleWarehouseAddress: 'Lageradresse bearbeiten',
            previousPageTitle: 'Organisationskonto',
        },
        accountEditAddressNotFound: {
            notFoundMessage: 'Diese Adresse konnte nicht gefunden werden.',
            pageTitle: 'Adresse bearbeiten',
            previousPageTitle: 'Organisationskonto',
        },
        accountEditEmail: {
            pageTitle: 'E-Mail-Adresse bearbeiten',
            previousPageTitle: 'Kontoübersicht',
            successNotification:
                'Eine E-Mail mit Anweisungen zur Bestätigung dieser E-Mail-Adresse wurde an {{userEmail}} gesendet.',
        },
        accountChangePassword: {
            pageTitle: 'Passwort ändern',
            incorrectPassword: 'Das aktuelle Passwort ist falsch.',
            rateLimitError:
                'Leider haben Sie die maximal zulässige Anzahl an Versuchen zur Änderung Ihres Passworts überschritten. Bitte versuchen Sie es nach einer Stunde erneut.',
            genericErrorMessage:
                'Wir können Ihr Passwort derzeit nicht zurücksetzen. Bitte versuchen Sie es später noch einmal.',
        },
        accountMFA: {
            pageTitle: 'Zwei-Faktor-Authentifizierung',
            previousPageTitle: 'Kontoübersicht',
            info: 'Erhalten Sie Bestätigungscodes direkt von einer App anstatt lange auf Textnachrichten zu warten. Das funktioniert auch, wenn Ihr Telefon offline ist. Laden Sie zunächst die Authenticator-App aus dem Google Play Store oder dem iOS App Store herunter.',
            inputLabel: '6-stelliger Code',
            submit: 'Weiter',
            validationFailed: 'Die Validierung ist fehlgeschlagen',
            codeMismatch: 'Nichtübereinstimmung des Codes',
            genericError: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
        },
        accountEditPaymentTerms: {
            formItemHeader: 'Zahlungsbedingungen',
            inputLabel: '',
            pageTitle: 'Zahlungseinstellungen',
            previousPageTitle: 'Organisationskonto',
            saveButtonLabel: 'Speichern',
            saveErrorMessage:
                'Das Speichern der Änderungen ist fehlgeschlagen. Bitte versuchen Sie es später noch einmal.',
        },
        accountValidateEmail: {
            emailUpdated: 'Ihre E-Mail-Adresse wurde aktualisiert.',
            unableToUpdateEmail:
                'Wir können Ihre E-Mail-Adresse derzeit nicht aktualisieren. Bitte versuchen Sie es später erneut.',
        },
        addressDetails: {
            additionalInformationLabel: 'Weitere Informationen',
            collectionInformationLabel: 'Zusätzliche Informationen für die Abholung',
            deliveryTimeframeLabel: 'Lieferzeitraum',
            deliveryInformationLabel: 'Hinweise zur Lieferadresse (optional)',
            addressNotLoadable: 'Adresse konnte nicht geladen werden.',
            chooseAddressButtonLabel: 'Wählen Sie eine andere Adresse',
            deliveryInfoCollectionLabel: 'Abholadresse',
            sectionHeading: {
                [AddressIdentifier.BILLING_ADDRESS]: 'Rechnungsadresse',
                [AddressIdentifier.DELIVERY_ADDRESS]: 'Lieferadresse',
                [AddressIdentifier.PICKUP_ADDRESS]: 'Abholadresse',
                [AddressIdentifier.DELIVERY_INFO]: 'Lieferinformationen',
            },
        },
        addUser: {
            headerTitle: 'Neuen Benutzer hinzufügen',
            backLinkText: 'Benutzerverwaltung',
            addUserButtonLabel: 'Speichern',
        },
        dashboard: {
            headerTitle: 'Willkommen {{name}}!',
            bannerSearch: {
                header: 'Finden Sie Ihr Material',
                body: 'Nutzen Sie die flexible Materialsuche, richten Sie Suchaufträge ein und lassen Sie uns genau das Richtige für Sie finden.',
                buttonLabel: 'Angebote suchen',
            },
            bannerSell: {
                header: 'Verkaufen Sie Ihre Produkte',
                body: 'Stellen Sie Ihre Produkte ein und behalten Sie Ihre Angebote und Verkäufe im Blick.',
                buttonLabel1: 'Angebot erstellen',
                buttonLabel2: 'Meine Angebote',
            },
            urgentRequests: {
                headerTitle: 'Materialanfragen für schnelle Verkäufe nutzen',
                helperText:
                    'Beantworten Sie Materialanfragen von Käufern im Handumdrehen mit passenden Angeboten. Sobald Ihr Angebot freigegeben und online ist, benachrichtigen wir den Käufer über den neuen Treffer.',
                noUrgentRequests: 'Derzeit liegen keine Materialanfragen vor.',
                viewAll: 'Alle anzeigen',
            },
            bannerRequest: {
                header: 'Material direkt anfragen',
                body: 'Erreichen Sie unser gesamtes Verkäufernetzwerk und erhalten Sie innerhalb weniger Stunden passende Angebote.',
                buttonLabel: 'Material anfragen',
            },
        },
        dashboardListings: {
            headerTitle: 'Dashboard',
            materialSelectionHeading: 'Material erkunden',
            results: {
                header_zero: '{{count}} Ergebnisse',
                header_one: '{{count}} Ergebnis',
                header_other: '{{count}} Ergebnisse',
            },
            tableHeadings: {
                productName: 'Produktname',
                gauge: 'Stärke',
                quality: 'Qualität',
                location: 'Standort',
            },
            sortByOption: 'Sortieren nach: {{option}}',
            filter: {
                buttonLabel: 'Filter',
                gaugeThickness: 'Dicke / Stärke',
            },
            viewDeliveredPrice: 'Gelieferten Preis anzeigen',
            deliveredTotal: 'Gelieferte Gesamtmenge auf der Produktseite verfügbar',
            hrpoShort: 'HRPO',
        },
        dashboardRfq: {
            bannerNewAtSteelBuy: {
                header: 'Neu bei SteelBuy: Walzprodukte',
                body: 'Senden Sie Ihre Angebotsanfrage (RFQ) für benötigtes Material an viele Werke gleichzeitig. In Ruhe vergleichen, einfach bestellen.',
                buttonLabel: 'RFQ erstellen',
            },
        },
        addToCartConfirmModal: {
            headline: 'Erfolgreich zum Warenkorb hinzugefügt',
            continueShopping: 'Weiter einkaufen',
            viewCart: 'Warenkorb ansehen',
            checkoutBtn_one: 'Zur Kasse ({{count}} Artikel)',
            checkoutBtn_other: 'Zur Kasse ({{count}} Artikel)',
            addToCartFailed:
                'Der Artikel ist möglicherweise abgelaufen oder verkauft und kann nicht in Ihren Warenkorb gelegt werden.',
            alreadyInCart: 'Dieses Angebot befindet sich bereits im Warenkorb.',
            actFast: 'Handeln Sie schnell! Ihr Warenkorb wird automatisch geleert in <time>{{time}}</time>',
            actFastSmallScreenModal: 'Handeln Sie schnell! <time>{{time}}</time>',
            itemsNotReserved:
                'Hinzugefügte Artikel werden nicht reserviert und können jederzeit von anderen Kunden gekauft werden.',
            itemsNotReservedSmallScreenModal: 'Artikel können von anderen gekauft werden.',
            insufficientCredit:
                'Ihr Kreditrahmen reicht nicht aus, um diesen Artikel in den Warenkorb zu legen. Bitte passen Sie Ihren Kreditrahmen an, um fortzufahren.',
        },
        cart: {
            entrySuccessMessage: 'Ihr Angebot wurde aus dem Warenkorb entfernt.',
            entryErrorMessage: 'Eintrag konnte nicht aus dem Warenkorb entfernt werden. Bitte versuchen Sie es erneut.',
            expiredMessage:
                'Ihre Reservierung ist abgelaufen und die Artikel aus Ihrem Warenkorb wurden entfernt. Bitte starten Sie eine neue Suche, um Artikel wieder in Ihren Warenkorb zu legen.',
            insufficientCreditMessage:
                'Der Kauf ist nicht möglich, da einige Artikel in Ihrem Warenkorb aufgrund unzureichenden Kreditrahmens nicht gekauft werden können.',
        },
        cartReminderNotification: {
            message: 'Der Warenkorb wird in <time>{{time}} Minuten</time> automatisch geleert',
            checkoutButtonLabel_one: 'Zur Kasse gehen ({{count}} Artikel)',
            checkoutButtonLabel_other: 'Zur Kasse gehen ({{count}} Artikel)',
        },
        checkout: {
            cancel: {
                content: 'Ihre Bestellung wird gelöscht.',
                confirmButtonLabel: 'Bestätigen',
            },
            header: {
                title: 'Kasse',
            },
            checkbox1Label:
                'Durch Ankreuzen dieses Kästchens erkläre ich, dass ich berechtigt bin, diesen Vertrag für und im Namen von abzuschließen {{organisationName}}.',
            checkbox2Label:
                'Indem ich dieses Kästchen ankreuze, stimme ich für und im Namen von zu {{organisationName}} dass ich die folgenden Geschäftsbedingungen gelesen habe und ihnen zustimme: <websitetncs>Allgemeine Geschäftsbedingungen der Website,</websitetncs> <buyertncs>Allgemeine Geschäftsbedingungen für Käufer</buyertncs>.',
            negotiationExists: 'Ein anderes Mitglied Ihrer Organisation verhandelt derzeit über diesen Punkt.',
            creditLimitExceeded:
                'Der Preis dieses Produkts übersteigt Ihr verbleibendes Kreditlimit. Brauchen Sie Hilfe? Kontaktieren Sie den Support: {{email}}',
            delivery: {
                title: 'Lieferung',
                haulierRequiredMessage: 'Müssen wir für diesen Artikel einen Liefertermin buchen?',
                materialLocationLabel: 'Materialstandort',
            },

            purchaseOrderNumber: 'Ihre Bestellnummer',
            purchaseOrderPlaceholderText: 'PO3874387',
            purchaseOrderErrorMsg: 'Bitte geben Sie eine gültige Bestellnummer ein',
            deliveryText: 'Voraussichtliche Lieferzeit',
            payment: {
                creditInfoNotification: 'Der Betrag wird von Ihrem Kreditrahmen abgezogen.',
                sectionHeading: 'Zahlung',
                optionCreditLabel: 'Kredit',
                optionCreditExplanation: 'Ihre Bestellung wird direkt versendet.',
                optionUpfrontLabel: 'Vorauszahlung',
                optionUpfrontExplanation: 'Ihre Bestellung wird versendet, nachdem wir Ihre Zahlung erhalten haben.',
            },
            priceUpdatedError: 'Der Listenpreis wurde aktualisiert. Bitte überprüfen Sie den neuen Preis vor dem Kauf.',
            pricePerUnitInclDelivery: 'Preis pro {{tradeUnit}} (inkl. Lieferung)',
            shippingCostsLabel: 'Lieferung',
            incompleteInformationNotification:
                'Bitte geben Sie alle erforderlichen Informationen ein, um den Kauf abzuschließen.',
            submitCheckoutButtonLabel: 'Kauf abschließen',
            totalPriceSectionHeading: 'Gewicht und Preis',
            totalExclVat: 'Gesamt (exkl. MwSt.)',
            itemsTotalExclVat: 'Artikel Gesamt (exkl. MwSt.)',
            itemsTotal: 'Artikel Gesamt',
            totalInclVat: 'Gesamt (inkl. MwSt.)',
            vatLabel: '+ {{value}}% MwSt',
            weight: 'Gewicht',
            theoreticalWeight: 'Theoretisches Gewicht',
            offerDetails: 'Details zum Preisvorschlag',
            error: {
                pageTitle: 'Entschuldigung. Wir konnten Ihre Bestellung nicht aufgeben.',
                retryMessage:
                    'Wenn die Bestellung nach einem erneuten Versuch nicht aufgegeben werden kann, wenden Sie sich bitte an <link1>{{email}}</link1> um Hilfe.',
                contactMessage: 'Die Bestellung konnte nicht aufgegeben werden.  <link1>{{email}}</link1> um Hilfe.',
                contactSupport: 'Kontaktieren Sie den Support',
                retry: 'Wiederholen',
                link: 'Zurück zur Checkout-Seite',
                unableToPurchaseCartWithRetry:
                    'Leider konnten wir Ihre Bestellung nicht aufgeben. Wenn die Bestellung nach einem erneuten Versuch nicht aufgegeben werden kann, wenden Sie sich bitte an <link1>{{email}}</link1>, um Hilfe zu erhalten.',
                unableToPurchaseCartAfterRetryExceeded:
                    'Leider konnten wir Ihre Bestellung nicht aufgeben. Bitte kontaktieren Sie <link1>{{email}}</link1>, um Hilfe zu erhalten.',
                creditLimitExceedContactSupport:
                    'Sie haben Ihr aktuelles Kreditlimit überschritten. Bitte kontaktieren Sie <link1>{{email}}</link1>, um Hilfe zu erhalten.',
            },
        },
        checkoutAddAddress: {
            errorMessage: 'Adresse konnte nicht hinzugefügt werden. Bitte versuchen Sie es später noch einmal.',
            pageTitle: 'Neue Adresse hinzufügen',
            previousPageTitle: 'Wählen Sie Adresse',
        },
        checkoutChooseAddress: {
            pageTitle: 'Kasse',
        },
        checkoutDeliveryOption: {
            headerLabel: 'Lieferoption',
            headerDescriptionLabel: 'Sollte SteelBuy alle Artikel an eine oder mehrere Adressen liefern?',
            singleAddressLabel: 'Einzeladresse',
            singleAddressDescriptionLabel: 'Ihre Bestellung wird an eine Adresse versendet.',
            multipleAddressLabel: 'Mehrere Adressen',
            multipleAddressDescriptionLabel: 'Ihre Bestellung wird an mehrere Adressen versendet.',
            orderSummary: 'Bestellübersicht',
            totalWeight: 'Gesamtgewicht',
        },
        checkoutSuccess: {
            header: {
                title: 'Kasse',
            },
            successText: 'SteelBuy hat Ihre Bestellung erhalten!',
            orderNumberText: 'SteelBuy-Bestellnummer:',
            purchaseOrderNumber: 'Ihre Bestellnummer:',
            steelbuyReferenceNumber: 'Referenznummer von SteelBuy:',
            emailHint: 'Sie erhalten eine E-Mail mit Kaufbestätigung, Rechnung und Prüfzertifikat.',
            deliveryHint: 'SteelBuy übernimmt die Abholung und Lieferung des Materials.',
            banner: {
                headline: 'Haben Sie Fragen zu Ihrer Bestellung?',
                contactText: 'Wir sind jederzeit für Sie erreichbar:',
                emailLabel: 'E-Mail:',
            },
            searchListingsButtonLabel: 'Angebote suchen',
            manageOrder: 'Verwalten Sie Ihre Bestellung unter <link1>Meine Bestellungen</link1>',
        },
        checkoutSuccessDynamicDelivery: {
            header: {
                title: 'Bestellung bestätigt',
            },
            successText1: 'Ihre Transaktion wurde erfolgreich auf SteelBuy ausgeführt.',
            successText2:
                'SteelBuy hat den Preis fixiert, überprüft, dass das Material gesichert ist, und die Abwicklungsprozesse eingeleitet.',
            orderId: 'Bestellnummer:',
            timestamp: 'Zeitstempel:',
            whatsHappeningNow: 'Was passiert jetzt',
            documentationIssued: 'Digitale Dokumentation ausgestellt',
            documentationIssuedHint:
                'Sie erhalten eine automatische Bestätigung einschließlich Rechnung und Prüfzertifikaten.',
            logisticsUnderway: 'Logistikkoordination läuft',
            logisticsUnderwayHint:
                'SteelBuy koordiniert Abholung, Eigentumsübertragung und Lieferung gemäß den vereinbarten Bedingungen.',
            realTimeVisibility: 'Echtzeit-Transparenz',
            realTimeVisibilityHint:
                'Verfolgen Sie den Bestellstatus, Dokumente und Versandaktualisierungen jederzeit unter „Meine Bestellungen“.',
            sourceMaterial: 'Mehr Material beschaffen',
            viewOrderDetails: 'Bestelldetails anzeigen',
        },
        contactDetails: {
            header: {
                title: 'Kontaktieren Sie uns',
            },
        },
        createAlert: {
            title: 'Wählen Sie "Material anfragen“, wenn Sie Materialien sofort benötigen. Wir leiten Ihre Anfrage dann direkt an unsere Verkäufer weiter.',
            urgentRequest: 'Materialanfrage stellen',
            nonUrgentRequest: 'Normalen Suchauftrag anlegen',
        },
        createListingAddPickupAddress: {
            errorMessage: 'Adresse konnte nicht hinzugefügt werden. Bitte versuchen Sie es später noch einmal.',
            pageTitle: 'Lageradresse hinzufügen',
            previousPageTitle: 'Wählen Sie Abholadresse',
        },
        createListingOverview: {
            notificationSuccess: 'Ihr Entwurf wurde erfolgreich gelöscht.',
            notificationError: 'Ihr Entwurf konnte nicht gelöscht werden.',
        },
        createListingListUpload: {
            packageTitleHeader: 'Pakettitel',
            packageTitleLabel: 'Der Pakettitel für Käufer',
            packageTitlePlaceholder: 'z.B. 20 Spulen, verzinkt, warmgewalzt...',
            packageDescriptionLabel: 'Die Paketbeschreibung für Käufer',
            packageDescriptionHeader: 'Paketbeschreibung',
            packageDescriptionPlaceholder:
                'Bitte beschreiben Sie Ihr Paket, damit Käufer leicht verstehen können, was darin enthalten ist.',
            packageListUploadHeader: 'Paketangebote-Upload (Excel-Datei)',
            packageListUploadLabel: 'Laden Sie eine Excel-Datei hoch, die alle Artikel im Paket enthält',
            packageFileInputHelperText: 'Excel-Datei ({{fileType}})',
        },
        createListingChoosePickupAddress: {
            pageTitle: 'Wählen Sie Abholadresse',
            previousPageTitle: 'Angebot erstellen',
        },
        createListing: {
            draftSuccessfulNotification: 'Ihr Entwurf wurde erfolgreich gespeichert.',
            draftFailedNotification: 'Eintrag konnte nicht als Entwurf gespeichert werden.',
            packageDraftFailedNotification: 'Das Paket konnte nicht als Entwurf gespeichert werden.',
            headerCreateNew: 'Angebot erstellen',
            headerEditDraft: 'Entwurfsliste bearbeiten',
            rejectedListingConvertedToDraft:
                'Das abgelehnte Angebot wurde in einen Entwurf umgewandelt. Es wird jetzt unter "Meine Angebote" aufgeführt.',

            targetPriceHeader: 'Zielpreis',
        },
        createListingPortal: {
            header: 'Angebot erstellen',
            single: {
                heading: 'Einzelnes Angebot erstellen',
                description: 'Ideal, wenn du ein einzelnes Angebot einstellen möchtest oder gerade erst anfängst.',
                button: 'Ein Angebot erstellen',
            },
            bulk: {
                heading: 'Mehrere Angebote hochladen',
                description: 'Empfohlen, wenn du mehrere Angebote in einer Tabelle vorbereitet hast.',
                button: 'Tabelle hochladen',
            },
        },
        createBulkListing: {
            header: 'Mehrere Angebote hochladen',
            goBack: 'Angebot erstellen',
            chooseMaterial: {
                header: 'Wählen Sie Ihr gewünschtes Material',
            },
            importListing: {
                header: 'Angebote per XLS importieren',
                label: 'Tabelle mit Angeboten hochladen',
                fileInputHelperText: '.xls, .xlsx',
                uploadError: 'Fehler beim Lesen der Datei.',
            },
            labels: {
                CHOOSE_MATERIAL: 'Material auswählen',
                IMPORT_LISTINGS: 'Angebote importieren',
                EDIT_LISTINGS: 'Angebote bearbeiten',
                EXPIRY_DATE: 'Verfallsdatum',
            },
            editListings: {
                header: 'Angebote bearbeiten ({{count}})',
                successMessage: `Hochladen abgeschlossen. Wir haben Ihre Einträge extrahiert und sie können jetzt überprüft werden. In einigen Feldern sind möglicherweise noch Eingaben erforderlich. Bitte überprüfen Sie vor dem Absenden die unten aufgeführten Details.`,
                summaryMessage:
                    '{{uploadedCount}} Einträge hochgeladen. {{incompleteCount}} warten auf deine Überprüfung.',
                completeness: 'Vollständigkeit',
                completed: 'Vollendet ({{filled}}/{{total}})',
                sellingPrice: 'Verkaufspreis pro {{pricingUnit}}',
                listingDeleted: 'Der Eintrag wurde erfolgreich gelöscht.',
                collectionAddress: 'Abholadresse',
                notApplicable: 'n. z.',
                unsavedChanges:
                    'Diese Einträge enthalten nicht gespeicherte Änderungen. Möchten Sie als Entwurf speichern, bevor Sie zurückkehren?',
            },
            expiryDate: {
                header: 'Verfallsdatum',
            },
            fields: {
                weight: 'Gewicht ({{tradeUnit}})',
                theoreticalWeight: 'Theoretisches Gewicht ({{tradeUnit}})',
                sellingPrice: 'Verkaufspreis',
                price: 'Preis (pro Tonne)',
                testCertificate: 'Prüfzertifikat',
                picture: 'Bild',
                collectionAddress: 'Abholadresse',
                expiryDate: 'Ablaufdatum',
                autoRenewal: 'Automatische Verlängerung',
                yes: 'Ja',
                no: 'Nein',
                priceValue: '{{price}}/{{pricingUnit}}',
                testCertToFollow: 'Folgt',
                description: 'Detaillierte Beschreibung',
                width: 'Breite ({{- unit}})',
                thickness: 'Dicke ({{- unit}})',
                length: 'Länge ({{- unit}})',
            },
            editListingModal: {
                header: 'Eintrag bearbeiten ({{index}}/{{total}})',
                incompleteNotification: 'Bitte füllen Sie alle fehlenden Felder aus.',
                uploadTestCertificate: 'Prüfzeugnis hochladen',
                previouslyUploadedLabel: 'Wählen Sie eine zuvor hochgeladene Datei aus',
                uploadNewFile: 'Neue Datei hochladen',
                uploadNewFileNow: 'Jetzt neue Datei hochladen',
                testCertToFollow: 'Testzertifikat folgt',
                inputWeightLabel: 'Gewicht ({{tradeUnit}})',
                theoreticalWeight: 'Theoretisches Gewicht ({{tradeUnit}})',
                files: 'Dateien',
                successNotification: 'Angebot wurde aktualisiert',
                saveAndNext: 'Speichern und weiter',
                saveAndNextTooltip: 'Änderungen speichern und zum nächsten Angebot wechseln',
                saveTooltip: 'Änderungen speichern und Popup schließen',
                materialIdLabel: 'Material-ID',
                deleteListingLabel: 'Angebot löschen',
                saveAndNextHelper: 'Speichern und weiter = Speichern und zum nächsten gehen',
                selectTestCertNotification: 'Bitte wählen Sie 1 Datei aus.',
            },
            summary: {
                submitListings: 'Angebot einreichen',
                listings: 'Angebot',
                totalListings: 'Gesamtangebote',
                totalDocuments: 'Gesamtdokumente',
                totalImages: 'Gesamtzahl der Bilder',
                failedSubmissionMessage:
                    'Einträge konnten nicht übermittelt werden. Bitte versuchen Sie es später noch einmal.',
            },
            deleteModal: {
                textContent: 'Sind Sie sicher, dass Sie dieses Angebot löschen möchten?',
            },
        },
        createBulkListingSuccess: {
            buttonLabelCreateNew: 'Angebot erstellen',
            marketingBannerHeader: 'Haben Sie Fragen zu Ihren Angeboten?',
            nextStepReview:
                'Unser Team wird die Angebote überprüfen, um sicherzustellen, dass sie die Qualitätsstandards erfüllen.',
            notificationMessage: 'Ihre Angebote werden überprüft.',
        },
        createListingDraftNotFound: {
            pageTitle: 'Angebotsentwurf nicht gefunden',
            previousPageTitle: 'Überblick',
            notificationMessage:
                'Dieser Eintragsentwurf konnte nicht gefunden werden. Er wurde möglicherweise gelöscht oder zur Überprüfung veröffentlicht.',
            notificationButtonLabel: 'Neuen Angebot erstellen',
        },
        createListingSaveDraftButton: {
            label: 'Als Entwurf speichern',
        },
        createListingSteps: {
            labels: {
                [Steps.MATERIAL]: 'Materialien',
                [Steps.DIMENSIONS]: 'Abmessungen',
                [Steps.WEIGHT_PRICE]: 'Gewicht und Preis',
                [Steps.PICKUP_ADDRESS]: 'Abholadresse',
                [Steps.LIST_UPLOAD]: 'Listen-Upload',
                [Steps.DELIVERY_INFO]: 'Lieferinformationen',
            },
        },
        createListingButtons: {
            viewSummaryButtonLabel: 'Zusammenfassung anzeigen',
            wizardNextButtonLabel: 'Weiter',
        },
        createListingSuccess: {
            buttonLabelCreateNew: 'Neues Angebot erstellen',
            buttonLabelCreateSame: 'Ähnliches Angebot erstellen',
            buttonLabelMyListings: 'Meine Angebote',
            header: 'Angebot erstellen',
            marketingBannerHeader: 'Haben Sie Fragen zu Ihrem Angebot?',
            marketingBannerText: 'Wir sind jederzeit für Sie erreichbar:',
            nextStepsHint: 'Nächste Schritte',
            nextStepNotification:
                'Sie erhalten eine Benachrichtigung, sobald wir Ihr Angebot freigeben und online stellen.',
            nextStepReview:
                'Unser Team prüft Ihr Angebot, um sicherzustellen, dass es unseren Qualitätsstandards entspricht.',
            notificationMessage: 'Ihr Angebot liegt uns zur Prüfung vor.',
        },
        createListingSummary: {
            errorNotificationMessage: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
            header: 'Zusammenfassung',
            submitButtonLabel: 'Eintrag einreichen',
            weightAndPriceHeader: 'Gewicht und Ihr Verkaufspreis',
            weightAndPriceNotification: 'Zu Ihrem Preis addieren wir eine Liefer- und Servicegebühr.',
            weightAndPriceNotificationTheoretical:
                'Zu Ihrem Preis addieren wir eine Liefer- und Servicegebühr. Sie verkaufen diesen Artikel nur auf Grundlage des theoretischen Gewichts.',
            checkboxLabel:
                'Indem ich dieses Kästchen ankreuze, stimme ich für und im Namen von zu {{organisationName}} dass ich die folgenden Geschäftsbedingungen gelesen habe und ihnen zustimme: <websitetncs>Allgemeine Geschäftsbedingungen der Website</websitetncs>, <sellertncs>Allgemeine Geschäftsbedingungen des Verkäufers</sellertncs>',
            websiteTCLinkText: 'Allgemeine Geschäftsbedingungen der Website',
            sellerTCLinkText: 'Allgemeine Geschäftsbedingungen des Verkäufers',
        },
        createListingUnsavedChangesModal: {
            discardButtonLabel: 'Änderungen verwerfen',
            headline: 'Dieser Eintrag weist nicht gespeicherte Änderungen auf.',
            savingFailedNotification: 'Das Speichern ist fehlgeschlagen. Bitte versuchen Sie es später noch einmal.',
        },
        createRFQUnsavedChangesModal: {
            headline: 'Diese Angebotsanfrage weist nicht gespeicherte Änderungen auf.',
        },
        createRFQ: {
            headerCreateNew: 'RFQ erstellen',
            headerEditDraft: 'RFQ Entwurf bearbeiten',
            submitButtonLabel: 'RFQ einreichen',
            chooseMaterial: 'Wählen Sie Ihr Wunschmaterial',
            addItems: 'Artikel zu Ihrer Angebotsanfrage (RFQ) hinzufügen',
            chooseMaterialOrigin: 'Wählen Sie die bevorzugte Materialherkunft und den gewünschten Liefermonat',
            wizardNextButtonLabel: 'Weiter',
            viewSummary: 'Zusammenfassung anzeigen',
            comments: 'Kommentare',
            selectPlaceholder: 'Wählen Sie Optionen',
            addSimilar: 'Ähnliches hinzufügen',
            actions: 'Aktionen',
            addToRFQ: 'Zur Angebotsanfrage hinzufügen',
            saveAsDraft: 'Als Entwurf speichern',
            deleteRFQItemConfirmation: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
            materialOrigin: {
                header: 'Bevorzugte Materialherkunft(en)',
                description:
                    'Bitte wählen Sie einen oder mehrere Herkunftsorte aus. (EU-Länder, Vereinigtes Königreich, Schweiz, Norwegen)',
            },
            preferredOrigin: 'Bevorzugte Herkunft(en)',
            deliveryMonth: {
                header: 'Gewünschter Liefermonat',
                description: 'Bitte wählen Sie im Dropdown-Menü den gewünschten Liefermonat aus.',
                subHeader: 'Gewünschter Liefermonat',
            },
            fieldRequired: 'Dieses Feld ist erforderlich.',
            quoteDeadline: {
                header: 'Angebotsfrist',
                subHeader: 'Angebotsfrist',
                description:
                    'Bitte geben Sie das Datum an, bis zu dem Sie spätestens Angebote von Lieferanten erhalten möchten. Das Angebot verfällt nach Ablauf des von Ihnen gewählten Datums.',
            },
            additionalComments: {
                header: 'Zusätzliche Kommentare',
                description: 'Bei Bedarf können Sie potenziellen Anbietern weitere Informationen zukommen lassen.',
            },
            rfqDetails: 'RFQ-Details',
            downloadRfq: 'Angebotsanfrage herunterladen',
            rfqReferenceNumber: 'RFQ-Referenznummer',
        },
        myRFQ: {
            header: 'Meine RFQs',
            submitted: 'Eingereicht',
            drafts: 'Entwürfe',
            noResultsDescription: 'Erstellen Sie eine neue Anfrage für das Material, das Sie kaufen möchten.',
            noListingsCallToAction: 'RFQ erstellen',
            numberOfRFQListings_zero: 'Keine RFQs',
            numberOfRFQListings_one: '{{count}} RFQ',
            numberOfRFQListings_other: '{{count}} RFQs',
            notificationMsg:
                'Die Lieferanten können die Produktliste prüfen und ein Angebot abgeben. Sie können das Angebot annehmen oder ablehnen.',
            publishRfq: 'RFQ VERÖFFENTLICHEN',
            createSimilarRFQ: 'Erstellen Sie eine ähnliche Ausschreibung',
            statusText: {
                header: {
                    [RFQStatus.UNDER_REVIEW]: 'Zur Überprüfung eingereicht unter:',
                    [RFQStatus.REJECTED]: 'Abgelehnt bei:',
                    [RFQStatus.LIVE]: 'Veröffentlicht am:',
                    [RFQStatus.WITHDRAWN]: 'Zurückgezogen am:',
                    [RFQStatus.EXPIRED]: 'Abgelaufen am:',
                },
            },
            emailSubject: 'Ablehnung der Angebotsanfrage {{quoteRef}}',
        },
        myRFQDetails: {
            withdrawRfq: 'Anfrage zurückziehen',
            withdrawSuccess: 'Ihre Angebotsanfrage wurde zurückgezogen.',
            withdrawFailure: 'Ihre Anfrage konnte nicht zurückgezogen werden. Bitte versuchen Sie es später erneut.',
            withdrawModal: {
                header: 'Sind Sie sicher, dass Sie Ihre Angebotsanfrage zurückziehen möchten?',
                confirmLabel: 'Anfrage zurückziehen',
            },
            updateFailure: 'Ihre Anfrage konnte nicht veröffentlicht werden. Bitte versuchen Sie es später erneut.',
            success: 'Ihre Ausschreibung ist online.',
            notificationMsg:
                'Sie können diese Angebotsanfrage erneuern, indem Sie eine neue Angebotsfrist festlegen. Damit veröffentlichen Sie Ihren RFQ direkt an die Verkäufer. Für eine Anpassung der Anfragedetails klicken Sie auf „Ähnliche Anfrage erstellen“.',
            restartRFQSuccess:
                'Die abgelehnte Anfrage wurde in einen Anfrageentwurf umgewandelt. Sie wird nun unter „Meine Anfragen“ aufgeführt.',
            restartRFQFailure: 'Die Konvertierung in den RFQ-Entwurf ist fehlgeschlagen. ',
        },
        myRFQDraft: {
            numberOfRFQDraftListings_zero: 'Keine Entwürfe',
            numberOfRFQDraftListings_one: '{{count}} Entwurf',
            numberOfRFQDraftListings_other: '{{count}} Entwürfe',
        },
        myQuotes: {
            tableHeadings: {
                materialSpecs: 'Materialspezifikationen',
                totalWeight: 'Gesamtgewicht',
                rfqStatus: 'RFQ-Status',
                createdAt: 'Erstellt am',
                rfqReferenceNo: 'RFQ-Referenznr',
            },
            rfqStatus: {
                [RFQStatus.UNDER_REVIEW]: 'Offen',
            },
            extraListingsCount: '+{{count}} mehr',
        },
        myRFQFilter: {
            selectLabel: 'Filtern nach',
            selectPlaceholder: 'Wählen Sie Optionen',
            optionLabels: {
                [RFQStatus.REJECTED]: 'Abgelehnt',
                [RFQStatus.LIVE]: 'Online',
                [RFQStatus.WITHDRAWN]: 'Zurückgezogen',
                [RFQStatus.EXPIRED]: 'Abgelaufen',
                [RFQStatus.UNDER_REVIEW]: 'In Prüfung',
            },
        },
        myCart: {
            header: 'Warenkorb',
            infoMsg:
                'Hinzugefügte Artikel werden nicht reserviert und können jederzeit von anderen Kunden gekauft werden.',
            noItemCallToAction: 'Angebote suchen',
            noItemCaption: 'Ihr Warenkorb ist leer',
            noResultsDescription: 'Finden Sie jetzt passende Angebote.',
            itemsExpiredOrSold:
                'Einige Artikel sind möglicherweise abgelaufen oder wurden verkauft. Ihr Warenkorb wurde entsprechend aktualisiert.',
            itemsRenewed: '<property>{{property}}:</property> von {{oldPrice}} bis {{newPrice}} {{pricingUnit}}',
            itemsRenewedMessage:
                'Für {{count}} der Artikel in Ihrem Warenkorb gibt es eine neue Preisaktualisierung vom Verkäufer.',
        },
        createRFQSteps: {
            labels: {
                [RFQStep.CHOOSE_MATERIALS]: 'Materialien wählen',
                [RFQStep.ADD_ITEMS]: 'Elemente hinzufügen',
                [RFQStep.SHIPPING_DETAILS]: 'Versanddetails',
                [RFQStep.COMMENTS]: 'Kommentare',
            },
        },
        createRFQSuccess: {
            buttonLabelCreateNew: 'RFQ erstellen',
            buttonLabelMyListings: 'Meine RFQs',
            header: 'RFQ erstellen',
            marketingBannerHeader: 'Haben Sie Fragen zu Ihrem RFQ?',
            marketingBannerText: 'Wir sind jederzeit für Sie erreichbar:',
            nextStepsHint: 'Nächste Schritte',
            nextStepNotification:
                'Sie erhalten eine Benachrichtigung, sobald wir Ihren RFQ freigeben und online stellen.',
            nextStepReview:
                'Unser Team prüft Ihre Angebotsanfrage, um sicherzustellen, dass sie unseren Qualitätsstandards entspricht.',
            notificationMessage: 'Ihr RFQ wird jetzt von uns geprüft.',
            referenceNumber: 'RFQ-Referenznummer: ',
            matchesHeader: 'Sofortige Produkttreffer',
            matchesDescription1: 'Sofortige Treffer aus bestehenden Marktplatzangeboten gefunden.',
            matchesDescription2: 'Sie können diese auf der RFQ-Detailseite einsehen.',
            noMatches: 'Keine passenden Angebote gefunden',
        },
        createRFQSummary: {
            submitButtonLabel: 'RFQ einreichen',
            header: 'Zusammenfassung',
            createRFQFailed: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
        },
        createDraftRFQ: {
            createDraftRFQFailed: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
            createDraftRFQSuccess: 'Ihr Entwurf wurde erfolgreich gespeichert.',
        },
        addRfq: {
            addTitle: 'Neues Element hinzufügen',
            addDescription:
                'Um einen Artikel hinzuzufügen, füllen Sie bitte alle Felder in der Zeile aus. Klicken Sie anschließend auf „Zur Anfrage hinzufügen“, um fortzufahren.',
            itemExists: 'Artikel ist bereits vorhanden. Bitte ändern.',
            genericError: 'Ungültige Formularwerte.',
        },
        legalCheckboxes: {
            checkbox1Label:
                'Durch Ankreuzen dieses Kästchens erkläre ich, dass ich berechtigt bin, diesen Vertrag für und im Namen von abzuschließen {{organisationName}}.',
            checkbox2Label:
                'Indem ich dieses Kästchen ankreuze, stimme ich für und im Namen von zu {{organisationName}} dass ich die folgenden Geschäftsbedingungen gelesen habe und ihnen zustimme: <websitetncs>Allgemeine Geschäftsbedingungen der Website</websitetncs>, <buyertncs>Allgemeine Geschäftsbedingungen für Käufer</buyertncs>.',
        },
        editUser: {
            headerTitle: 'Benutzer bearbeiten',
            backLinkText: 'Benutzerverwaltung',
            saveUserButtonLabel: 'Speichern',
            toggleUserSuccess: {
                enabled: 'Der Benutzer wurde erfolgreich reaktiviert',
                disabled: 'Der Benutzer wurde erfolgreich deaktiviert',
            },
            toggleUserError: {
                enabled: 'Benutzer konnte nicht deaktiviert werden. Bitte versuchen Sie es später erneut.',
                disabled: 'Benutzer konnte nicht reaktiviert werden. Bitte versuchen Sie es später erneut.',
            },
        },
        footer: {
            termsLinkText: 'Allgemeine Geschäftsbedingungen',
            contactDetailsLinkText: 'Kontaktieren Sie uns',
            privacyPolicyLinkText: 'Datenschutzrichtlinie',
            acceptableUseLinkText: 'Richtlinien zur akzeptablen Nutzung',
            claimsPolicyText: 'Reklamationsrichtlinie',
        },
        genericError: {
            dashboardButtonLabel: 'Gehen Sie zum Dashboard',
            helperText:
                'Hoppla! Etwas ist schiefgelaufen. Bitte gehen Sie zurück oder versuchen Sie, die Seite neu zu laden.',
            reloadButtonLabel: 'Neu laden',
        },
        legal: {
            headerTitle: 'Rechtliche Hinweise',
        },
        listingDetails: {
            detailedDescription: 'Detaillierte Beschreibung',
            testCertificateTitle: 'Prüfzertifikat',
            deliveryTitle: 'Lieferung',
            deliveryText: 'Voraussichtliche Lieferzeit',
            checkoutButtonText: 'Jetzt kaufen',
            offerButtonText: 'Preisvorschlag abgeben',
            packageListSheetTitle: 'Paketlistentabelle',
            fetchingPriceMessage:
                'Bitte warten Sie, während wir die neuesten Preisinformationen abrufen. Bitte versuchen Sie es erneut, sobald der Preis aktualisiert wurde.',
        },
        listingNotFound: {
            notFoundMessage: 'Leider ist dieses Produkt nicht mehr verfügbar.',
            newSearchMessage: 'Vielleicht wartet bereits ein ähnliches Produkt auf Sie?',
            newSearchButton: 'Neue Suche starten',
        },
        listingSearchForm: {
            headerTitle: 'Angebote suchen',
            theoreticalWeightNotification: 'Maximal mögliches theoretisches Gewicht.',
        },
        ListingSearchFormInputs: {
            refineSearch: 'Verfeinern Sie Ihre Suche',
            incompleteInformationNotification:
                'Bitte füllen Sie alle erforderlichen Informationen aus, um Ihre Materialanfrage einzureichen.',
            submitText: 'Suchen',
            weightLabel: 'Erforderliches Gewicht',
            theoreticalWeightLabel:
                'Sie werden nur über Material informiert, das auf dem theoretischen Gewicht basiert.',
            targetPriceHeader: 'Gewünschter Zielpreis',
            targetPriceDescription:
                'Bitte beachten Sie, dass Angebote, die weit unter dem Marktwert liegen, von Verkäufern möglicherweise übersehen werden.',
            targetPriceLabel: 'Gewünschter Zielpreis (optional)',
            minimumTargetPriceError: 'Bitte geben Sie einen höheren Betrag ein, der dem Marktwert entspricht',
            numberOfItems: {
                [Product.SHEET]: 'Erforderliche Blattanzahl',
                [Product.PLATE]: 'Erforderliche Anzahl an Tellern',
                [Product.TREAD]: 'Erforderliche Anzahl Riffelbleche',
                [Product.FLOOR]: 'Erforderliche Anzahl Bodenplatten',
            },
        },
        listingAlertNotification: {
            explanation:
                'Erstellen Sie einen Suchauftrag und wir benachrichtigen Sie per E-Mail über neue Suchergebnisse. ',
            createSuccess: 'Ihr Suchauftrag wurde erfolgreich angelegt. ',
            deleteSuccess: 'Ihr Suchauftrag wurde erfolgreich gelöscht.',
            link: 'Sie finden Ihre Suchaufträge unter „Meine Suchaufträge“.',
        },
        listingSearchResults: {
            addAlertButtonLabel: 'Suchauftrag erstellen',
            deleteAlertButtonLabel: 'Suchauftrag löschen',
            header: {
                title: 'Suchergebnisse',
                backLinkText: 'Suchkriterien',
            },
            editSearchButtonTitle: 'Suche bearbeiten',
            noResultsText: 'Derzeit gibt es keine Ergebnisse für Ihre Suche.',
            noResultsButtonLabel: 'Suchkriterien bearbeiten',
        },
        locationAwareGenericError: {
            pageTitle: 'Etwas ist schief gelaufen',
        },
        materialStep: {
            anonymityBannerHeader: 'Sie bleiben anonym!',
            anonymityBannerText: 'SteelBuy anonymisiert hochgeladene Zertifikate für Sie.',
            missingProductsNotification: 'Ihr Produkt ist nicht dabei?',
            missingProductsLinkLabel: 'Kontaktieren Sie uns.',
            missingProductsEmailSubject: 'Fehlendes Produkt',
        },
        myAccount: {
            myAccountCardHeader: 'Mein Konto',
            myAccountCardEmailLabel: 'E-Mail',
            myAccountCardNameLabel: 'Name',
            editEmailAddress: 'E-Mail-Adresse bearbeiten',
            passwordCardButtonLabel: 'Passwort ändern',
            passwordCardHeader: 'Passwort',
            permissionCardHeader: 'Meine Berechtigungen',
            mfa: {
                header: 'Zwei-Faktor-Authentifizierung',
                button: 'Einstellungen ändern',
                enabled: 'Ermöglicht',
                disabled: 'Deaktiviert',
            },
        },
        myAlertsOverview: {
            deleteSuccess: 'Ihr Suchauftrag wurde erfolgreich gelöscht.',
            pageHeader: 'Meine Benachrichtigungen',
            pageHeaderButton: 'Neue Suche starten',
        },
        myOffers: {
            pageHeader: 'Meine Preisvorschläge',
            dataHeader: {
                numberOfOffers_zero: 'Keine Preisvorschläge',
                numberOfOffers_one: '{{count}} Preisvorschläge',
                numberOfOffers_other: '{{count}} Preisvorschläge',
            },
            noResultsText: 'Derzeit liegen keine Angebote vor.',
            infoMsg:
                'Der Verkäufer kann den vorgeschlagenen Preis überprüfen und entscheiden, ob er das Angebot annimmt, ablehnt oder widerspricht. Wenn vor Datum und Uhrzeit keine Maßnahmen ergriffen werden, wird die Verhandlung automatisch abgebrochen.',
        },
        myAlertsSearchResults: {
            pageHeader: 'Ergebnisse',
            previousPageTitle: 'Meine Benachrichtigungen',
            notificationIllustratedHeader: 'Treffer!',
            notificationIlulustratedHelperText: 'Wir haben neue Angebote gefunden, die Ihrer Suche entsprechen',
            searchSummaryNewResults: '{{numListings}} neu',
        },
        myAlertsSettings: {
            changesSavedNotificationMessage: 'Ihre Änderungen wurden gespeichert!',
            deleteButtonLabel: 'Suchauftrag löschen',
            header: 'Alarmeinstellungen',
            headerBackLinkLabel: 'Meine Benachrichtigungen',
            mailNotificationHeader: 'E-Mail-Benachrichtigungen',
            mailNotificationLabel:
                'Wir benachrichtigen Sie per E-Mail an {{email}} über jedes neue Angebot, das Ihrer Suche entspricht.',
            receiveNotifications: 'Benachrichtigungen aktivieren',
            saveButtonLabel: 'Speichern',
            errorHeading: 'Für den Zugriff ist die Verkäuferrolle erforderlich',
            errorMessage:
                'Diese Einstellung ist nur für Benutzer mit der Rolle „Verkäufer“ verfügbar. Bitte wenden Sie sich an einen Administrator, wenn Sie Zugriff benötigen.',
        },
        myListings: {
            header: 'Meine Angebote',
            noResultsDescription: 'Erstellen Sie ein neues Angebot für das Material, das Sie verkaufen möchten.',
            noListingsCallToAction: 'Angebot erstellen',
            numberOfListings_zero: 'Keine Einzelangebote',
            numberOfListings_one: '{{count}} Angebot',
            numberOfListings_other: '{{count}} Angebote',
            numberOfDrafts_zero: 'Keine Entwürfe',
            numberOfDrafts_one: '{{count}} Entwurf',
            numberOfDrafts_other: '{{count}} Entwürfe',
            listings: 'Angebote',
            drafts: 'Entwürfe',
            subTabListingLabel: 'Einzelangebote',
            subTabDraftsLabel: 'Hauptentwürfe',
            bulkFilterNotification:
                'Sie sehen derzeit einen gefilterten Satz von Einträgen nach der Bulk-Upload-ID. Sehen Sie sich alle Einträge nach an',
            bulkRemoveFilter: 'Entfernen des Filters.',
        },
        myPackages: {
            numberOfPackageListings_zero: 'Keine Paketangebote',
            numberOfPackageListings_one: '{{count}} Paketangebot',
            numberOfPackageListings_other: '{{count}} Paketangebote',
            numberOfPackageDrafts_zero: 'Keine Entwürfe',
            numberOfPackageDrafts_one: '{{count}} Paketentwurf',
            numberOfPackageDrafts_other: '{{count}} Paketentwürfe',
            subTabPackageLabel: 'Paketangebote',
            subTabDraftsLabel: 'Paketentwürfe',
        },
        myBulkDrafts: {
            subTabDraftsLabel: 'Massenweise hochgeladene Entwürfe',
            deleteModal: {
                header: 'Sind Sie sicher, dass Sie alle {{count}} Einträge in diesem Entwurf löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
                deleteCta: 'Ja, alles löschen!',
            },
        },
        myListingsFilter: {
            selectLabel: 'Filtern nach',
            selectPlaceholder: 'Wählen Sie Optionen',
            optionLabels: {
                [ListingStatus.DRAFT]: 'Entwurf',
                [ListingStatus.REVIEW_REQUIRED]: 'In Prüfung',
                [ListingStatus.REVIEW_REJECTED]: 'Abgelehnt',
                [ListingStatus.PUBLISHED]: 'Online',
                [ListingStatus.PURCHASED]: 'Verkauft',
                [ListingStatus.WITHDRAWN]: 'Zurückgezogen',
                [ListingStatus.EXPIRED]: 'Abgelaufen',
            },
        },
        manageOffers: {
            pageHeader: 'Preisvorschläge',
            dataHeader: {
                numberOfOffers_zero: 'Keine Preisvorschläge',
                numberOfOffers_one: '{{count}} Preisvorschläge',
                numberOfOffers_other: '{{count}} Preisvorschläge',
            },
            noResultsText: 'Derzeit liegen keine Angebote vor.',
            infoMsg:
                'Der Käufer kann den Preisvorschlag annehmen, ablehnen oder einen Gegenvorschlag machen. Wird innerhalb der 24-Stunden-Verhandlungsfrist nichts unternommen, wird die Verhandlung automatisch abgebrochen.',
        },
        offerListingsFilter: {
            selectLabel: 'Filtern nach',
            selectPlaceholder: 'Wählen Sie Optionen',
            awaitingYourResponse: 'Warten auf Ihre Antwort',
            optionLabels: {
                [OfferListingStatus.AWAITING_BUYER]: 'Warten auf Antwort des Käufers',
                [OfferListingStatus.AWAITING_SELLER]: 'Warten auf die Antwort des Verkäufers',
                [OfferListingStatus.ACCEPTED]: 'Akzeptiert',
                [OfferListingStatus.REJECTED]: 'Abgelehnt',
                [OfferListingStatus.WITHDRAWN]: 'Zurückgezogen',
                [OfferListingStatus.EXPIRED]: 'Abgelaufen',
                [OfferListingStatus.CANCELLED]: 'Abgesagt',
                [OfferListingStatus.PURCHASED]: 'Verkauft',
            },
        },
        offers: {
            negotiationsHeader: 'Sie verhandeln über dieses Angebot',
            accordionHeader: 'Referenznummer der Verhandlung: {{referenceId}}',
            timeLeft: 'Verbleibende Zeit, um Maßnahmen zu ergreifen',
            tableHeadings: {
                offersAndCounterOffers: 'Gebot(e) und Gegengebot(e)',
                date: 'Datum',
                requestBy: 'Anfrage von',
                action: 'Aktion',
            },
            reject: 'Ablehnen',
            counter: 'Schalter',
            accept: 'Akzeptieren',
            withdraw: 'Angebot zurückziehen',
            hours: 'Std.',
            minutes: 'Minuten',
            acceptModelHeader: 'Möchten Sie dieses Angebot wirklich annehmen?',
            buyNowModalheader:
                'Bestehendes Angebot in Bearbeitung. Sind Sie sicher, dass Sie mit dem Kauf zum Originalpreis fortfahren möchten?',
            addToCartModalHeader:
                'Bestehendes Angebot in Bearbeitung. Sind Sie sicher, dass Sie das Angebot zum Originalpreis in den Warenkorb legen möchten?',
            buynow: 'Jetzt kaufen',
            submitCounterOffer: 'Gegengebot abgeben',
            review: 'Weiter',
            priceExceed: 'Der von Ihnen eingegebene Betrag ist höher als der Originalpreis.',
            minimumPriceError: 'Bitte geben Sie einen höheren Betrag ein, der dem Marktwert entspricht.',
            limitPriceExceed: 'Der von Ihnen eingegebene Betrag überschreitet Ihr Kreditlimit.',
            buyerCounterInfoMsg: 'Wir senden Ihnen innerhalb von {{timeLeft}} eine Antwort vom Käufer',
            sellerCounterInfoMsg: 'Wir senden Ihnen innerhalb von {{timeLeft}} eine Antwort vom Verkäufer',
            counterOffer: 'Ihr Gegengebot',
            reviewCounterOffer: 'Überprüfen Sie Ihr Gegengebot',
            pricelabel: 'Originalpreis pro {{pricingUnit}}',
            buyerOfferedPriceLabel: 'Angebot des Käufers pro {{pricingUnit}}',
            sellerOfferedPriceLabel: 'Angebot des Verkäufers pro {{pricingUnit}}',
            proposedPrice: 'Ihr vorgeschlagener Preis pro {{pricingUnit}}',
            total: 'Gesamt',
            reviewPricingUnit: {
                [PricingUnit.TON]: {
                    label: 'Gewicht',
                },
                [PricingUnit.KILOGRAM]: {
                    label: 'Gewicht',
                },
                [PricingUnit.SHEET]: {
                    label: 'Artikel',
                },
                [PricingUnit.PLATE]: {
                    label: 'Artikel',
                },
                [PricingUnit.TREAD]: {
                    label: 'Artikel',
                },
                [PricingUnit.CWT]: {
                    label: 'Gewicht',
                },
                [PricingUnit.LB]: {
                    label: 'Gewicht',
                },
            },
            rejectModelHeader: 'Möchten Sie diesen Preisvorschlag wirklich ablehnen?',
            withdrawModalHeader: 'Möchten Sie Ihr Gebot wirklich zurückziehen?',
            counterMsgSeller:
                'Ihr Gegengebot ist eingegangen. Sie können in Kürze mit einer Antwort des Käufers rechnen.',
            counterMsgBuyer:
                'Ihr Angebot ist eingegangen. Sie können in Kürze mit einer Antwort des Verkäufers rechnen.',
            counterErrorMSg: 'Derzeit kann dem Angebot nicht widersprochen werden. Bitte versuchen Sie es erneut.',
            acceptErrorMsg: 'Der Preisvorschlag kann derzeit nicht angenommen werden. Bitte versuchen Sie es erneut.',
            rejectErrorMsg: 'Das Angebot kann derzeit nicht abgelehnt werden. Bitte versuchen Sie es erneut.',
            withdrawErrorMsg: 'Das Angebot kann derzeit nicht zurückgezogen werden. Bitte versuchen Sie es erneut.',
            acceptMsgBuyer:
                'Sie haben den Preisvorschlag des Verkäufers angenommen. Sie haben 24 Stunden Zeit, um den Kauf abzuschließen.',
            rejectMsgBuyer: 'Sie haben den Preisvorschlag abgelehnt.',
            withdrawMsg: 'Ihr Gebot wurde zurückgezogen.',
            acceptMsgSeller:
                'Der Verkäufer hat den Preisvorschlag angenommen. Das Angebot ist bis zum Ablauf der Anfragefrist zu diesem Preis verfügbar.',
            rejectMsgSeller: 'Der Verkäufer hat Ihren Preisvorschlag abgelehnt.',
            notificationMsgBuyer:
                'Der Verkäufer kann den vorgeschlagenen Preis überprüfen und entscheiden, ob er das Angebot annimmt, ablehnt oder widerspricht. Wenn vor Datum und Uhrzeit keine Maßnahmen ergriffen werden, wird die Verhandlung automatisch abgebrochen.',
            notificationMsgSeller:
                'Der Käufer kann den Preisvorschlag annehmen, ablehnen oder einen Gegenvorschlag machen. Wird innerhalb der 24-Stunden-Verhandlungsfrist nichts unternommen, wird die Verhandlung automatisch abgebrochen.',
            notifyNewOffer:
                'Sie haben neue Angebote, die auf Ihre Entscheidung warten. Bitte überprüfen Sie die vorgeschlagenen Preise und entscheiden Sie sich je nach Bedarf für die Annahme, Ablehnung oder Ablehnung jedes Angebots.',
            respondToOffer: 'Auf Angebot(e) reagieren',
        },
        myOrders: {
            header: 'Meine Bestellungen',
            numberOfOrders_zero: 'Keine Bestellungen',
            numberOfOrders_one: '1 Bestellung',
            numberOfOrders_other: '{{count}} Bestellungen',
            noResultsDescription: 'Keine Ergebnisse entsprechen diesen Filteroptionen.',
            noOrdersCallToAction: 'Filter löschen',
            bannerBuy: {
                header: 'Kaufen Sie Ihr erstes Produkt',
                subHeader: 'Kaufen Sie Material und profitieren Sie von unserem SteelBuy-Versprechen:',
                description: [
                    'Sofortiger Zugriff auf Materialien, um Ihre Zeit zu maximieren.',
                    'Der schnellste Weg, Stahl zu kaufen, bei dem die Technologie die Arbeit erledigt.',
                    'Vollständig verwalteter Bestellvorgang.',
                ],
                buttonLabel: 'Angebote suchen',
            },
            searchPlaceHolder: 'Ihre Bestellnummer',
            noOrdersCallToActionClearSearch: 'Suche löschen',
            noOrdersCallToActionClearBoth: 'Klare Suche und Filter',
            noResultsDescriptionForSearch: 'Keine Ergebnisse für "{{number}}"',
            noResultsDescriptionForBoth:
                'Für "{{number}}" oder passend zu den ausgewählten Filteroptionen wurden keine Ergebnisse gefunden.',
        },
        myOrdersFilter: {
            selectLabel: 'Filtern nach',
            selectPlaceholder: 'Wählen Sie eine Option',
        },
        myOrderDetails: {
            marketingBannerHeader: 'Haben Sie Fragen zu Ihrer Bestellung?',
            marketingBannerText: 'Wir sind jederzeit für Sie erreichbar:',
            purchaseOrderNumbersHeader: 'Bestellnummern',
            purchaseOrderNumberHeader: 'Bestellnummer',
            steelbuyPurchaseOrderNumberLabel: 'SteelBuy Bestellnr.',
            buyerPurchaseOrderNumberLabel: 'Ihre Bestellnr.',
            backLinkText: 'Meine Bestellungen',
            steelBuyReferenceNoLabel: 'SteelBuy-Referenznr',
        },
        myOrderDetailsNotFound: {
            pageTitle: 'Bestellung nicht gefunden',
            previousPageTitle: 'Meine Bestellungen',
            notFoundMessage: 'Diese Bestellung konnte nicht gefunden werden.',
        },
        myOrderDetailsStatus: {
            cardHeader: 'Bestellstatus',
            delivered: 'Geliefert',
            delivery: 'Lieferung',
            freight_booked: 'Fracht gebucht',
            processing: 'Bearbeitungsauftrag',
            processed: 'Bestellung bearbeitet',
            shipping: 'Versand',
            shippingConfirmed: 'Versand bestätigt',
        },
        offerSuccess: {
            title: 'Ihr Preisvorschlag',
            successText: 'SteelBuy hat Ihren Preisvorschlag erhalten!',
            referenceNumberText: 'SteelBuy-Referenznummer:',
            responseHint: 'Der Verkäufer wird in Kürze auf Ihren Preisvorschlag reagieren.',
            manageOffers: 'Verwalten Sie Ihre Preisvorschläge unter <link1>Meine Preisvorschläge</link1>.',
        },
        pickupAddressStep: {
            anonymityBannerHeader: 'Sie bleiben anonym!',
            anonymityBannerText: 'Ihre Adresse wird für die Abholung benötigt und ist nur für SteelBuy sichtbar.',
            incompleteInformationNotification:
                'Bitte geben Sie vollständige Informationen ein, um mit der Zusammenfassung fortzufahren.',
            filesUploadingNotification: 'Bitte warten Sie, bis der Upload der Dateien abgeschlossen ist.',
            additionalInformationLabel: 'Zusätzliche Informationen für die Abholung (optional)',
            additionalInfoPlaceholder: 'z. B. Parkhinweise oder Kontaktinformationen für das Lagerpersonal',
            deliveryTimeframeHeader: 'Lieferzeitraum',
            deliveryTimeframeLabel: 'Ihr Lieferzeitraum für das aktuelle Paket.',
        },
        privacyPolicy: {
            headerTitle: 'Datenschutzrichtlinie',
            cookieLinks: {
                edge: 'https://enablecookies.info/#en-edge',
                safari: 'https://enablecookies.info/#en-safari',
                chrome: 'https://enablecookies.info/#en-chrome',
                firefox: 'https://enablecookies.info/#en-firefox',
                opera: 'https://enablecookies.info/#en-opera',
            },
        },
        purchaseContactEdit: {
            backLinkText: 'Organisationskonto',
            emailFieldLabel: 'E-Mail-Adresse',
            headerTitle: 'Ansprechpartner',
            nameFieldLabel: 'Name',
            notificationErrorMessage: 'Das Speichern ist fehlgeschlagen. Bitte versuchen Sie es später noch einmal',
            saveButtonLabel: 'Speichern',
        },
        renewListingSuccess: {
            notificationMessage: 'Ihr Eintrag ist online!',
            notificationHelperText: 'SteelBuy-Eintrags-ID: {{steelbuyListingID}}',
            bannerHeader: 'Haben Sie Fragen zu Ihrem Eintrag?',
            bannerText: 'Wir sind jederzeit für Sie erreichbar:',
            myListingsButtonLabel: 'Meine Angebote',
        },
        rfqHeadingLabels: {
            grade: 'Güteklasse',
            specification: 'Spezifikation',
            finish: 'Finish',
            width: 'Breite',
            thickness: 'Dicke',
            length: 'Länge',
            weight: 'Gewicht',
            tolerance: 'Toleranz',
            surface: 'Oberfläche',
            coating: 'Beschichtung',
            coatingThicknessValue: 'Beschichtungsdicke',
            gradeFamily: 'Gütefamilie',
            coatingWeight: 'Beschichtungsgewicht',
            surfaceTreatment: 'Oberflächenbehandlung',
            compliance: 'Konformität',
            surfaceFinish: 'Oberflächenfinish',
            temper: 'Vergüten',
            thicknessOption: 'Dickenoptionen',
            thicknessType: 'Dickentyp',
            thicknessMax: 'Dicke',
            deliveryAddress: 'Lieferadresse',
        },
        sellerListingDetails: {
            rejectionReason: {
                title: 'Ablehnungsgrund',
                description: 'Wenden Sie sich an den Support, wenn Sie Fragen zum Überprüfungsprozess haben.',
                buttonLabel: 'Kontaktieren Sie den Support',
                emailSubject: 'Ablehnung der Listung {{sellerSku}}',
            },
            weightAndSellingPrice: {
                title: 'Gewicht und Preis',
                offerTitle: 'Gewicht und Ihr Verkaufspreis',
                weight: 'Originalgewicht und Preis',
                notification: 'Zu Ihrem Preis addieren wir eine Liefer- und Servicegebühr.',
                offerNotification: 'Zum Gesamtpreis des Käufers berechnen wir eine Liefer- und Servicegebühr.',
                newSellingPriceHeader: 'Ihr neuer Verkaufspreis pro {{tradeUnit}}',
            },
            checkboxLabel:
                'Indem ich dieses Kästchen ankreuze, stimme ich für und im Namen von zu {{organisationName}} dass ich die folgenden Geschäftsbedingungen gelesen habe und ihnen zustimme: <websitetncs>Allgemeine Geschäftsbedingungen der Website</websitetncs>, <sellertncs>Allgemeine Geschäftsbedingungen des Verkäufers</sellertncs>.',
            createSameButtonLabel: 'Ähnliches Angebot erstellen',
            renewButtonLabel: 'Auf dem Marktplatz veröffentlichen',
            save: 'Speichern',
            listingHasUnsavedChanges: 'Dieser Eintrag weist nicht gespeicherte Änderungen auf.',
            updateError: 'Änderungen am Eintrag konnten nicht gespeichert werden.',
            updateSuccess:
                'Ihre Aktualisierungen wurden erfolgreich gespeichert und werden auf dem Marktplatz angezeigt, sobald Ihr aktuelles Angebot abläuft und automatisch erneuert wird.',
        },
        sellerListingDetailsNotFound: {
            pageTitle: 'Eintrag nicht gefunden',
            previousPageTitle: 'Meine Angebote',
            notFoundMessage:
                'Dieser Eintrag konnte nicht gefunden werden. Er wurde möglicherweise in einen Eintragsentwurf umgewandelt.',
        },
        termsAndConditions: {
            pageHeader: 'Geschäftsbedingungen',
        },
        navigation: {
            itemLabels: {
                account: 'Konto',
                alerts: 'Meine Benachrichtigungen',
                createListing: 'Angebot erstellen',
                dashboard: 'Übersicht',
                manageOffers: 'Preisvorschläge',
                myListings: 'Meine Angebote',
                myOffers: 'Meine Preisvorschläge',
                myOrders: 'Meine Bestellungen',
                searchListing: 'Angebote suchen',
                requestMaterial: 'Material anfragen',
                activeRequests: 'Materialanfragen',
                createRfq: 'RFQ erstellen',
                myRfqs: 'Meine RFQs',
            },
            menuButtonLabel: 'Speisekarte',
        },
        navigationItemUser: {
            logoutButtonLabel: 'Abmelden',
        },
        navigationFooter: {
            loginButtonLabel: 'Login',
        },
        warehouseAddressSelection: {
            chooseAddressButtonLabel: 'Adresse wählen',
            addNewAddress: 'Neue Adresse hinzufügen',
        },
        organisation: {
            addressAddedNotificationText:
                'Vielen Dank, dass Sie eine neue Lageradresse hinzugefügt haben. Unser Betriebsteam validiert die neue Adresse, bevor sie in Ihrer Lageradressliste sichtbar wird. Seien Sie versichert, wir arbeiten daran.',
            addressDeletedNotificationText: 'Adresse wurde gelöscht.',
            addressUpdatedNotificationText: 'Adresse wurde aktualisiert.',
            createNewButtonLabel: 'Neue Adresse hinzufügen',
            creditCardHeader: 'Kredit',
            creditLineBalanceLabel: 'Restguthaben',
            creditLineTotalLabel: 'Gesamtguthaben',
            invoiceAddressCardHeader: 'Rechnungsadresse',
            organisationCardHeader: 'Unternehmen',
            organisationCardNameLabel: 'Name',
            organisationSavedNotificationText: 'Änderungen wurden erfolgreich gespeichert!',
            paymentSectionHeading: 'Zahlung',
            paymentTermsHeader: 'Zahlungsbedingungen für den Einkauf',
            paymentTerms: {
                [PaymentTerms.NET_30_DAYS]: '30 Tage ab Rechnungsdatum',
                [PaymentTerms.NET_60_DAYS]: '60 Tage ab Rechnungsdatum',
                [PaymentTerms.HALF_PERCENT_TEN_NET_30_DAYS]:
                    '0,5 % Skonto bei Zahlung innerhalb von 10 Tagen; ansonsten 30 Tage ab Rechnungsdatum',
                [PaymentTerms.ONE_PERCENT_TEN_NET_30_DAYS]:
                    '1 % Skonto bei Zahlung innerhalb von 10 Tagen; ansonsten 30 Tage ab Rechnungsdatum',
            },
            primaryAddressTag: 'Primär',
            purchaseContactCardHeader: 'Ansprechpartner',
            purchaseContactNameLabel: 'Name',
            purchaseContactEmailLabel: 'E-Mail',
            warehouseAddressHeader: 'Lageradresse {{number}}',
            warehouseAddressesSectionHeading: 'Lageradressen',
        },
        pageTitle: 'SteelBuy-Marktplatz',
        urgentRequests: {
            pageHeader: 'Materialanfrage',
            settingsButtonLabel: 'Einstellungen',
            newResultsSeparatorHeader_zero: 'Keine neuen Ergebnisse (letzte 24 Stunden)',
            newResultsSeparatorHeader_one: '1 Neues Ergebnis (letzte 24 Stunden)',
            newResultsSeparatorHeader_other: '{{count}} Neue Ergebnisse (letzte 24 Stunden)',
            emptyStateDescription: 'Derzeit liegen keine Materialanfragen vor.',
            createListing: 'Angebot erstellen',
            qna: {
                header: 'Fragen und Antworten',
                items: {
                    q1: {
                        label: 'Wie funktionieren Materialanfragen?',
                        content:
                            'Erstellen Sie als Verkäufer auf Grundlage der Materialanfrage eines Käufers ein passendes Angebot, über das wir den Käufer sofort informieren. Als Einkäufer können Sie nach Material suchen und sofortige Materialanfragen aktivieren. So benachrichtigen wir Sie per E-Mail, sobald passendes Material auf SteelBuy erscheint. Unter „Meine Benachrichtigungen“ können Sie Ihre Suchbenachrichtigungen verwalten.',
                    },
                    q2: {
                        label: 'Wie werde ich benachrichtigt?',
                        content:
                            'Sobald bei SteelBuy Materialanfragen auftauchen, senden wir eine Benachrichtigung an die E-Mail-Adresse Ihres Kontos.',
                    },
                    q3: {
                        label: 'Wie oft werde ich benachrichtigt?',
                        content:
                            'Aktuell erhalten Sie jedes Mal eine E-Mail, wenn eine neue Materialanfrage Ihren Kriterien entspricht. In den Benachrichtigungseinstellungen können Sie die gewünschte Benachrichtigungsfrequenz einstellen.',
                    },
                    q4: {
                        label: 'Wie kann ich Materialanfragen stummschalten?',
                        content:
                            'Sie können die Benachrichtigungen für Materialanfragen in den Einstellungen für Materialanfragen stummschalten oder löschen.',
                    },
                },
            },
            new: 'neu',
        },
        urgentRequestsSettings: {
            pageHeader: 'Materialanfrage Benachrichtigungseinstellungen',
            headerBackLinkLabel: 'Materialanfrage',
            changesSavedNotificationMessage: 'Ihre Änderungen wurden gespeichert!',
            mailNotificationHeader: 'E-Mail-Benachrichtigungen',
            mailNotificationLabel: 'Wir benachrichtigen Sie per E-Mail an {{email}} über jede neue Materialanfrage.',
            receiveNotifications: 'Benachrichtigungen aktivieren',
            saveButtonLabel: 'Speichern',
            notificationFrequencyHeader: 'Benachrichtigungs-Frequenz',
            notificationFrequencyLabel: 'Wie oft möchten Sie über neue Materialanfragen benachrichtigt werden?',
        },
        urgentRequestForm: {
            pageHeader: 'Material anfragen',
            warningMessage: 'Bitte füllen Sie alle erforderlichen Felder aus, um eine Materialanfrage zu stellen.',
            infoMessage: 'Bitte füllen Sie alle erforderlichen Felder aus, um eine Materialanfrage zu stellen.',
            submitButtonLabel: 'Anfrage abschicken',
            createdAlertMessageNoMatch: 'Sie haben erfolgreich eine Materialanfrage erstellt.',
            createdAlertMessageWithMatch:
                'Sie haben eine sofortige Materialanfrage erstellt und eine Übereinstimmung gefunden.',
            failedToCreate:
                'Wir können Ihre Benachrichtigung derzeit nicht erstellen. Bitte versuchen Sie es später erneut.',
        },
        userForm: {
            nameFieldLabel: 'Name',
            permissionsFieldLabel: 'Berechtigungen',
            emailFieldLabel: 'E-Mail-Adresse',
            activateToggleLabel: 'Aktiver Benutzer',
            deactivateUserModal: {
                modalTitle: 'Möchten Sie diesen Benutzer wirklich deaktivieren?',
                confirmButtonLabel: 'Bestätigen',
            },
            activateUserModal: {
                modalTitle: 'Möchten Sie diesen Benutzer wirklich reaktivieren?',
                confirmButtonLabel: 'Bestätigen',
            },
            errors: {
                invalidDomain: 'Die E-Mail muss von derselben Domäne wie die Organisation stammen',
                other: 'Fehler',
            },
        },
        userManagement: {
            emailHeader: 'E-Mail',
            permissionsHeader: 'Berechtigungen',
            createUserSuccess: 'Der Benutzer wurde erstellt!',
            updateUserSuccess: 'Der Benutzer wurde aktualisiert!',
        },
        time: {
            day_one: '1 Tag',
            day_other: '{{count}} Tage',
        },
    },
    error: {
        noUserError: 'Kein Benutzer geladen',
    },
};
